export default __webpack_public_path__ + "static/media/profile.0bcee0d9.svg";